import React, {useState, useEffect} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Select from 'react-select';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


var product_id = 0;
var Customer_ID = 0;
var Order_Number = 0;

function NewSpecial (){
  const [mode, setMode] = useState(false);
  const [Customers, SetCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/customers.json');
      const jsonresult = await result.json()
      SetCustomers(jsonresult)
    }
    fetchCustomers();
  }, [])

  const [Products, SetProducts] = useState([])

  const Buildings = [
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Shop', value: 'Shop' }
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/products.json');
      const jsonresult = await result.json()
      SetProducts(jsonresult)
    }
    fetchProducts();
  }, [])


  const handleProductChange = (event) => {
    product_id = event.value;
    var product = Products.find(product => product.id == product_id);

    if (product.product_type == "Carpet") {
      setMode(true);
    } else if (product.product_type == "Vinyl") {
      setMode(true);
    } else {
      setMode(false);
    };
  }

  var Building = "";
  const handleBuildingChange = (event) => {
    Building = event.value;
  }


  const handleCustomerChange = (event) => {
    Customer_ID = event.value;
  }

  var Location = "";
  const handleLocationChange = () => {
    var Location_ID = document.getElementById('Location_ID');
    Location = Location_ID.value;
  }

  var Length = 0;
  const setLength = () => {
    var length_select = document.getElementById('Length');
    Length = length_select.value;
  }

  var Width = 0;
  const setWidth = () => {
    var length_select = document.getElementById('Width');
    Width = length_select.value;
  }


  const setOrderNumber = () => {
    var OrderNumber_select = document.getElementById('Order_Number');
    Order_Number = OrderNumber_select.value;
  }

  var Quantity = 0;
  const setQuantity = () => {
    var Quantity_select = document.getElementById('Quantity');
    Quantity = Quantity_select.value;
  }

  var Consumable_Quantity = 0;
  const setConsumable_Quantity = () => {
    var Consumable_Quantity_select = document.getElementById('Consumable_Quantity');
    Consumable_Quantity = Consumable_Quantity_select.value;
  }

  var Consumable_Type = "";
  const setConsumable_Type = () => {
    var Consumable_Type_select = document.getElementById('Consumable_Type');
    Consumable_Type = Consumable_Type_select.options[Consumable_Type_select.selectedIndex].value;
  }

  var myData = "";
  const submitSpecial = async () => {
    myData = {
      stock: {
        stock_type_type: "StockFlooringRoll",
        product_id: product_id,
        in_stock: 1,
        customer_id: Customer_ID,
        order_number: Order_Number,
        building: Building,
        location: Location
      },
      stock_type: {
        width: Width,
        length: Length
      }
    }

    const result = await fetch(import.meta.env.VITE_URL + '/specials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
      })
      const resultInJson = await result.json()
  }

  return (

    <Form>
      <div className="row p-1">
        <div className="col"><h1>New Special Form</h1></div>
      </div>
      <Form.Text id="d" muted>
        Enter the order reference for this Special Item.
        <FloatingLabel id="label" label="Order Number" className='mb-3'>
          <Form.Control
            type="string"
            min="0"
            placeholder="Order Reference"
            id="Order_Number"
            onChange={setOrderNumber}
            required
          />
        </FloatingLabel>
      </Form.Text>

      <Form.Text id="d" muted>
        Select the customer this special belongs to
          <Select
            options={Customers.map(opt => ({ label: opt.customerdisplayname, value: opt.id }))}
            onChange={event => handleCustomerChange(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Select the Product
          <Select
            options={Products.map(opt => ({ label: opt.name, value: opt.id}))}
            onChange={event => handleProductChange(event)}
          />
      </Form.Text>
      {mode ?
      <div>
        <Form.Text id="Length_HelpBlock" muted>
          Enter the Length of the roll.
          <FloatingLabel id="floating_Length_label" label="Roll Length (M)" className="mb-3">
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              placeholder="Length"
              aria-describedby="Length_HelpBlock"
              id="Length"
              onChange={setLength}
              required
            />
          </FloatingLabel>
        </Form.Text>

        <Form.Text id="Width_HelpBlock" muted>
          Enter the Width of the roll.
          <FloatingLabel id="floating_Width_label" label="Roll Width (M)" className="mb-3">
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              placeholder="Width"
              aria-describedby="Width_HelpBlock"
              id="Width"
              required
              onChange={setWidth}
            />
          </FloatingLabel>
        </Form.Text>
      </div>
      :
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to add into Stock.
              <FloatingLabel id="label" label="Quantity" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Quantity"
                  id="Quantity"
                  onChange={setQuantity}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the container type.
              <FloatingLabel id="label" label="Consumable Type" className='mb-3'>
                <Form.Select
                  id="Consumable_Type"
                  onChange={setConsumable_Type}
                  required
                >
                </Form.Select>
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity in the container.
              <FloatingLabel id="label" label="Consumable Quantity" className='mb-3'>

                <Form.Select
                  id="Consumable_Quantity"
                  onChange={setConsumable_Quantity}
                  required
                >
                </Form.Select>
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>
      }
      <Form.Text id="d" muted>
        Select the Building the Special is located
          <Select
            options={Buildings}
            onChange={event => handleBuildingChange(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Enter the Positional Location of the Special Item.
        <FloatingLabel id="label" label="Positional Location" className='mb-3'>
          <Form.Control
            type="string"
            id="Location_ID"
            onChange={handleLocationChange}
          />
        </FloatingLabel>
      </Form.Text>

      <Button type="submit" onClick={submitSpecial}>Submit form</Button>

    </Form>

  );

}

export default NewSpecial;
